class ScentQuiz extends HTMLElement {
  constructor() {
    super();
    this.answers = {};
    this.steps = this.querySelectorAll('.scent-quiz__step');

    this.querySelector('.scent-quiz__start').addEventListener('click', () => this.goToStep('q1'));

    this.querySelectorAll('.scent-quiz__option').forEach((button) => {
      button.addEventListener('click', () => this.handleAnswer(button));
    });

    const retakeButton = this.querySelector('.scent-quiz__retake');
    if (retakeButton) {
      retakeButton.addEventListener('click', () => this.reset());
    }
  }

  handleAnswer(button) {
    const question = button.dataset.answer;
    const value = button.dataset.value;
    this.answers[question] = value;

    if (question === 'mood') {
      this.goToStep('q2');
    } else if (question === 'scent') {
      this.showResult();
    }
  }

  showResult() {
    const key = this.answers.mood + '-' + this.answers.scent;
    const cards = this.querySelectorAll('.scent-quiz__result-card');
    cards.forEach((card) => {
      const keys = (card.dataset.keys || '').split(' ');
      if (keys.indexOf(key) !== -1) {
        card.removeAttribute('hidden');
      } else {
        card.setAttribute('hidden', '');
      }
    });
    this.goToStep('result');
  }

  reset() {
    this.answers = {};
    this.goToStep('intro');
  }

  goToStep(stepName) {
    this.steps.forEach((step) => {
      step.classList.toggle('scent-quiz__step--active', step.dataset.step === stepName);
    });
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

customElements.define('scent-quiz', ScentQuiz);
